/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode } from 'react';
import styles from './OfferBadge.module.scss';
import clsx from 'clsx';
import { Badge } from '@gjensidige/builders-components';
import { InformationModal } from '../Common/InformationModal/InformationModal';

export interface IOfferBadgeProps {
  className?: string;
  modalHeading: string;
  modalMessage: string;
  linkText: string;
}

export function OfferBadge(props: IOfferBadgeProps) {
  return (
    <div className={clsx(styles.badgeParent, props.className)}>
      <div className={styles.badgeWrapper}>
        <div className={styles.badgeInnerWrapper}>
          <Badge className={styles.badge} severity="suggestive" arrow={true}>
            <InformationModal
              linkText={props.linkText}
              modalContent={[
                {
                  title: props.modalHeading,
                  details: props.modalMessage
                }
              ]}
              buttonSize="sm"
              buttonClassName="recommended-link"
              modalAriaLabel='Hjälp om vårt förslag'
            />
          </Badge>
        </div>
      </div>
    </div>
  );
}
